<template>
  <!-- 普通人员-首页 -->
  <div>
    <div>
      <!-- <a-row type="flex" justify="space-between" :gutter="16" style="margin-bottom: 14px;">
        <a-col :span="24">
          <personalOutlaysVue style="height: 200px;" />
        </a-col>
      </a-row>-->
      <a-row type="flex" justify="space-between" :gutter="16">
        <!-- <a-col :span="15">
          <briefingBoardVue style="height: 270px;"/>
        </a-col>-->
        <a-col :span="12">
          <internalAnnouncementVue @noticeTitled="noticeTitled" style="height: 640px;" />
        </a-col>
        <a-col :span="12">
          <approveVue
            @documentsJumped="documentsJumped"
            @approvaled="approvaled"
            ref="approveVue"
            style="height:640px;"
          />
        </a-col>
      </a-row>
      <!-- <a-row type="flex" justify="space-between" :gutter="16" style="margin-bottom:20px;">
        <a-col :span="15">
          <customerVue style="height: 300px;border-radius:10px;"/>
        </a-col>
        <a-col :span="9">
          <approveVue @documentsJumped="documentsJumped" @approvaled="approvaled" ref="approveVue" style="height:350px;"/>
        </a-col>
      </a-row>-->
    </div>
    <public-drawer
      ref="publicDrawerRef"
      :title="publicDrawer.title"
      :dialog-visible="publicDrawer.visible"
      :component-name="publicDrawer.comName"
      @projectChanges="publicDialogSucc"
      @close="handleClose"
    />
    <audit
      ref="auditRef"
      :dialog-visible="auditVisible"
      @projectChanges="projectChanges"
      @success="auditSucc"
      @close="auditClose"
    />
    <click-view ref="clickViewRef" :dialog-visible="clickViewVisible" @close="clickViewClose" />
  </div>
</template>

<script>
// 模块引入
import approveVue from '@/components/homeComponents/approve.vue' // 审批
import customerVue from '@/components/projectStatis/customerKanBan.vue' // 客户访问数量
import briefingBoardVue from '@/components/homeComponents/briefingBoard.vue' // 简报看板
import personalOutlaysVue from '@/components/homeComponents/personalOutlays.vue' // 个人财年支出
import internalAnnouncementVue from '@/components/homeComponents/internalAnnouncement.vue' // 内部公告
import publicDrawer from '../../components/drawer/copyDrawer.vue'
import audit from '../approvalManage/approvalData/audit.vue'
import clickView from '@/components/view/clickView.vue'
export default {
  name: 'AdminHome',
  components: {
    approveVue,
    briefingBoardVue,
    personalOutlaysVue,
    internalAnnouncementVue,
    customerVue,
    publicDrawer,
    audit,
    clickView
  },
  data () {
    return {
      clickViewVisible: false,
      auditVisible: false,
      userId: '',
      publicDrawer: {
        title: '',
        visible: false,
        comName: ''
      }
    }
  },
  beforeMount () {
    this.userId = this.$store.state.account.user.userId
  },
  methods: {
    noticeTitled (item) {
      this.publicDrawer.title = this.$tree([], 'system/notice/index')
      this.publicDrawer.visible = true
      this.publicDrawer.comName = 'system/notice/noticeDraw.vue'
      this.$nextTick(() => {
        this.$refs.publicDrawerRef.setForm(item)
      })
    },
    publicDialogSucc (value, name) {
      this.openView(value, name)
      // this.publicDrawer.visible = false
    },
    handleClose () {
      this.publicDrawer.visible = false
    },
    auditSucc () {
      this.auditVisible = false
      this.$refs.approveVue.approvalFrtch({ status: 4, userId: this.userId })
    },
    auditClose () {
      this.auditVisible = false
    },
    approvaled (value) {
      this.auditVisible = true
      this.$nextTick(() => {
        this.$refs.auditRef.setId(value)
      })
    },
    projectChanges (value, name) {
      // this.publicDia.visible = false
      if (name === 'project') {
        console.log('value.projectId =>', value.projectId)
        this.$get('/project/list', { id: value.projectId }).then(res => {
          // this.projectInfo = res.data.data.rows[0]
          if (res.data.data.rows && res.data.data.rows.length > 0) {
            this.openView(res.data.data.rows[0], 'project')
          } else {
            this.$message.warning('未查询到该数据，可能已删除或者没有操作权限，请检查！', 5)
          }
        })
      }
      if (name === 'customerName') this.openView(value, name)
      if (name === 'purchaseName') this.openView(value, name)
      if (name === 'contractName') this.openView(value, name)
    },
    openView (rowVal, name) {
      this.clickViewVisible = true
      if (name === 'purchaseName') {
        if (rowVal.purchaseId) this.$refs.clickViewRef.openView('purchase', rowVal, rowVal.purchaseId)
        else this.$refs.clickViewRef.openView('purchase', rowVal, rowVal.id)
      } else if (name === 'customerName') {
        this.$refs.clickViewRef.openView('customer', rowVal, rowVal.customerId)
      } else if (name === 'project') {
        this.$refs.clickViewRef.openView('project', rowVal, rowVal.projectId)
      } else if (name === 'contractName') {
        this.$refs.clickViewRef.openView('contract', rowVal, rowVal.id)
      }
    },
    clickViewClose () {
      this.clickViewVisible = false
    },
    // 点击详情
    documentsJumped (item) {
      this.documentsJump(item.rowVal, item.num)
    },
    documentsJump (rowVal, num) {
      if (rowVal.checkType === 0) {
        if (num === 1) {
          this.publicDrawer.title = this.$tree([], 'financialManage/expenseReim/index')
          this.publicDrawer.visible = true
          this.publicDrawer.comName = 'financialManage/expenseReim/show.vue'
          this.$get('/reimbursement/getById', { id: rowVal.recordId }).then(res => {
            this.$refs.publicDrawerRef.setForm(res.data.data)
          })
        } else this.openView(rowVal, 'customerName')
      } else if (rowVal.checkType === 1) {
        if (num === 1) {
          this.publicDrawer.title = this.$tree([], 'purchase/purchaseNote/index')
          this.publicDrawer.visible = true
          this.publicDrawer.comName = 'purchase/purchaseNote/viewDrawer.vue'
          this.$nextTick(() => {
            this.$refs.publicDrawerRef.setForm(rowVal.recordId)
          })
        } else this.openView(rowVal, 'customerName')
      } else if (rowVal.checkType === 2) {
        if (num === 1) {
          this.publicDrawer.visible = true
          this.publicDrawer.title = '预支预付'
          this.publicDrawer.comName = 'financialManage/advance/show.vue'
          this.$get('/prePayment/getById', { id: rowVal.recordId }).then(res => {
            if (res.data.status === 1) {
              this.$nextTick(() => {
                this.$refs.publicDrawerRef.setForm(res.data.data)
              })
            }
          })
        } else this.openView(rowVal, 'customerName')
      } else if (rowVal.checkType === 3 || rowVal.checkType === 4) {
        if (num === 1) {
          if (rowVal.isBack === 0) {
            this.publicDrawer.visible = true
            this.publicDrawer.title = this.$tree([], 'contractManage/paymentRecord/index')
            this.publicDrawer.comName = 'contractManage/paymentRecord/show.vue'
            this.$get('/payBack/getById', { backType: 1, id: rowVal.recordId }).then(res => {
              if (res.data.status === 1) {
                this.$refs.publicDrawerRef.setForm(res.data.data)
              }
            })
          } else if (rowVal.isBack === 1) {
            this.publicDrawer.visible = true
            this.publicDrawer.title = this.$tree([], 'purchase/paymentSchedule/index')
            this.publicDrawer.comName = 'purchase/paymentSchedule/paymentInfor.vue'
            this.$get('/payPlan/getById', { payType: 0, id: rowVal.recordId }).then(res => {
              if (res.data.status === 1) {
                this.$refs.publicDrawerRef.setForm(res.data.data)
              }
            })
          }
        } else this.openView(rowVal, 'customerName')
      } else if (rowVal.checkType === 5) {
        if (num === 1) {
          this.publicDrawer.visible = true
          this.publicDrawer.title = this.$tree([], 'offices/travelRecords/index')
          this.publicDrawer.comName = 'offices/travelRecords/details.vue'
          this.$get('outwork/byId', { id: rowVal.recordId }).then(res => {
            if (res.data.status === 1) {
              this.$nextTick(() => {
                this.$refs.publicDrawerRef.setForm(res.data.data)
              })
            }
          })
        } else this.openView(rowVal, 'customerName')
      } else if (rowVal.checkType === 6) {
        if (num === 1) {
          this.publicDrawer.visible = true
          this.publicDrawer.title = this.$tree([], 'offices/overtimeRecords/index')
          this.publicDrawer.comName = 'offices/overtimeRecords/details.vue'
          this.$get('outwork/byId', { id: rowVal.recordId }).then(res => {
            if (res.data.status === 1) {
              this.$nextTick(() => {
                this.$refs.publicDrawerRef.setForm(res.data.data)
              })
            }
          })
        } else this.openView(rowVal, 'customerName')
      } else if (rowVal.checkType === 7) {
        if (num === 1) {
          this.publicDrawer.title = this.$tree([], 'financialManage/largeAmountApplication/index')
          this.publicDrawer.visible = true
          this.publicDrawer.comName = 'financialManage/largeAmountApplication/show.vue'
          this.$get('bigAmount/byId', { id: rowVal.recordId }).then(res => {
            if (res.data.status === 1) {
              this.$nextTick(() => {
                this.$refs.publicDrawerRef.setForm(res.data.data)
              })
            }
          })
        } else this.openView(rowVal, 'customerName')
      } else if (rowVal.checkType === 8) {
        if (num === 1) {
          this.publicDrawer.title = this.$tree([], 'projectManage/projectProposals/index')
          this.publicDrawer.visible = true
          this.publicDrawer.comName = 'projectManage/projectProposals/detail.vue'
          this.$get('projectApproval/getById', { id: rowVal.recordId }).then(res => {
            if (res.data.status === 1) {
              this.$nextTick(() => {
                this.$refs.publicDrawerRef.setForm(res.data.data)
              })
            }
          })
        } else this.openView(rowVal, 'customerName')
      } else if (rowVal.checkType === 9) {
        if (num === 1) {
          this.publicDrawer.title = this.$tree([], 'offices/courtesyApplication/index')
          this.publicDrawer.visible = true
          this.publicDrawer.comName = 'offices/courtesyApplication/details.vue'
          this.$get('/festivalGift/getById', { id: rowVal.recordId }).then(res => {
            if (res.data.status === 1) {
              this.$nextTick(() => {
                this.$refs.publicDrawerRef.setForm(res.data.data)
              })
            }
          })
        } else this.openView(rowVal, 'customerName')
      } else if (rowVal.checkType === 10) {
        if (num === 1) {
          this.publicDrawer.title = this.$tree([], 'inventory/takeItBack/index')
          this.publicDrawer.visible = true
          this.publicDrawer.comName = 'inventory/takeItBack/details.vue'
          this.$get('/stockReceive/getById', { id: rowVal.recordId }).then(res => {
            if (res.data.status === 1) {
              this.$nextTick(() => {
                this.$refs.publicDrawerRef.setForm(res.data.data)
              })
            }
          })
        } else this.openView(rowVal, 'customerName')
      } else if (rowVal.checkType === 12) {
        if (num === 1) {
          this.publicDrawer.title = this.$tree([], 'manpower/recruitmentDemand/index')
          this.publicDrawer.visible = true
          this.publicDrawer.comName = 'manpower/recruitmentDemand/details.vue'
          this.$get('/recruitment/getById', { id: rowVal.recordId }).then(res => {
            if (res.data.status === 1) {
              this.$nextTick(() => {
                this.$refs.publicDrawerRef.setForm(res.data.data)
              })
            }
          })
        } else this.openView(rowVal, 'customerName')
      } else if (rowVal.checkType === 13) {
        if (num === 1) {
          this.publicDrawer.title = this.$tree([], 'contractManage/earnestMoney/index')
          this.publicDrawer.visible = true
          this.publicDrawer.comName = 'contractManage/earnestMoney/details.vue'
          this.$get('/performance/getById', { id: rowVal.recordId }).then(res => {
            if (res.data.status === 1) {
              this.$nextTick(() => {
                this.$refs.publicDrawerRef.setForm(res.data.data)
              })
            }
          })
        } else this.openView(rowVal, 'customerName')
      } else if (rowVal.checkType === 14) {
        if (num === 1) {
          this.publicDrawer.title = this.$tree([], 'offices/vehicleDepartureRecord/index')
          this.publicDrawer.visible = true
          this.publicDrawer.comName = 'offices/vehicleDepartureRecord/details.vue'
          this.$get('/outCar/byId', { id: rowVal.recordId }).then(res => {
            if (res.data.status === 1) {
              this.$nextTick(() => {
                this.$refs.publicDrawerRef.setForm(res.data.data)
              })
            }
          })
        } else this.openView(rowVal, 'customerName')
      } else if (rowVal.checkType === 15) {
        if (num === 1) {
          this.publicDrawer.title = this.$tree([], 'offices/returnCarRecord/index')
          this.publicDrawer.visible = true
          this.publicDrawer.comName = 'offices/returnCarRecord/details.vue'
          this.$get('/returnCar/byId', { id: rowVal.recordId }).then(res => {
            if (res.data.status === 1) {
              this.$nextTick(() => {
                this.$refs.publicDrawerRef.setForm(res.data.data)
              })
            }
          })
        } else this.openView(rowVal, 'customerName')
      }
      this.$refs.publicDrawerRef.isButtonShowFun(1)
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/roleHome/personHome.vue